<template>
    <div>
        <base-loading :visible="isLoading" />
        <base-modal :isOpen="isOpen" :title="$t('edit') | capitalize" @close="$emit('close')">
            <!-- Body -->
            <template #body>
                <vs-row class="mb-4">
                    <vs-col>
                        <vs-input :label="$t('description') | capitalize" :placeholder="$t('description') | capitalize"
                            v-model="description" class="w-full " disabled />
                    </vs-col>
                </vs-row>
                <vs-row class="mb-4">
                    <vs-col>
                        <vs-input :label="$t('quantity') | capitalize" :placeholder="$t('quantity') | capitalize"
                            v-model="quantity" class="w-full " disabled />
                    </vs-col>
                </vs-row>
                <vs-row class="mb-4">
                    <vs-col>
                        <label for="">{{ $t('range') | capitalize }}</label>
                    </vs-col>
                    <vs-col>
                        <v-select class="w-full" label="hours" :placeholder="$t('range') | capitalize" v-model="rangeId"
                            :reduce="(item) => item.id" :options="rangeList" :clearable="false">
                        </v-select>
                    </vs-col>

                </vs-row>
                 <vs-row class="mb-4">
                    <vs-col>
                        <vs-input type="text" :label="$t('days')" :placeholder="$t('days')" v-model="days"
                            class="w-full" />
                    </vs-col>
                </vs-row>
                <vs-row class="mb-4">
                    <vs-col>
                        <vs-input type="number" :label="$t('price')" :placeholder="$t('price')" v-model="unitPrice"
                            class="w-full" />
                    </vs-col>
                </vs-row>
                <vs-row class="mb-4">
                    <vs-col>
                        <vs-input type="number" label="Total" placeholder="Total" v-model="total" class="w-full" disabled/>
                    </vs-col>
                </vs-row>
            </template>

            <!-- Footer -->
            <template #footer>
                <vs-button color="danger" type="border" @click="$emit('close')"> {{ $t('cancel') | capitalize }}
                </vs-button>
                <vs-button color="success" @click="handleSubmit()"> {{ $t('save') | capitalize }} </vs-button>
            </template>
        </base-modal>
    </div>
</template>

<script>
import BaseModal from '@/views/app/components/modals/BaseModal.vue'
import vSelect from 'vue-select'
import request from '../request';
import BaseLoading from '@/views/app/components/loading/BaseLoading.vue';
export default {
    name: 'EditItemModal',
    components: { BaseModal, 'v-select': vSelect,BaseModal,BaseLoading },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: () => ({ id: '', description: '', range: '', rangeId: null, quantity: '', unit_price: '' })
        },
        rangeList: {
            type: Array,
            default: () => ([]),
            required:true
        }
    },
    data() {
        return {
            id: '',
            description: '',
            range: '',
            rangeId: null,
            quantity: '',
            unitPrice: '',
            days:'',
            aging:'',
            isLoading:false
        }
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                this.resetForm()
                this.id = this.item.id
                this.description = this.item.description
                this.range = this.item.range
                this.rangeId = this.item.range_id
                this.quantity = this.item.quantity
                this.unitPrice = this.item.unit_price
                this.aging = this.item.aging
                this.days = this.item.days
            }
        }
    },
    computed:{
        total(){
            return this.unitPrice * this.quantity * this.days;

        }
    },
    methods: {
        formatAmount(value) {
            return Number(value).toFixed(2);
        },

        resetForm() {
            this.id = ''
            this.description = ''
            this.range = ''
            this.rangeId = null
            this.quantity = ''
            this.unitPrice = ''
            this.days=''
            this.aging=''
        },
        handleSubmit() {
            const range = this.rangeList.find(el => el.id === this.rangeId);
            const item = {
                id:this.id,
                rangeId:this.rangeId,
                range: range.hours,
                days:this.days,
                unitPrice:this.unitPrice,
                total:this.total
            }
            this.$emit('close')
            this.$emit('update',item)
        },

    }
}

</script>

<style scoped></style>
